import { Pipe, PipeTransform } from '@angular/core';

/**
 * Absolute Value pipe
 * Takes a number value as an argument and returns its absolute value.
 *
 * Usage: date | absVal
 * Example:
 *  {{ -200 | absVal }}
 *  formats to 200
 */

@Pipe({
  name: 'absVal'
})
export class AbsoluteValuePipe implements PipeTransform {
  transform(num: number) {
    return Math.abs(num);
  }
}



// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/app/shared/pipes/absolute-value.pipe.ts